import { render, staticRenderFns } from "./cpjs.vue?vue&type=template&id=49a4c85c&scoped=true&"
import script from "./cpjs.vue?vue&type=script&lang=js&"
export * from "./cpjs.vue?vue&type=script&lang=js&"
import style0 from "./cpjs.vue?vue&type=style&index=0&id=49a4c85c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a4c85c",
  null
  
)

export default component.exports